import apiPaths from '../api-paths';

export default {
  // Pełna kartoteka pojazdów klienta — jedno wywołanie na okno, które podaje tę samą listę
  // wszystkim wierszom (komponent Vehicles.vue pobiera ją osobno dla każdego swojego wystąpienia).
  index({ query = '' } = {}) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/vehicles${ query }`);
  },
  show({ id }) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/vehicles/${ id }`);
  },
  update({ vehicle }) {
    if (vehicle.id === undefined) {
      throw new Error('Vehicle ID is required for update.');
    }

    return axios.put(`${ apiPaths.BOOKKEEPING }/vehicles/${ vehicle.id }`, { vehicle });
  },
  store({ vehicle }) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/vehicles`, { vehicle });
  },
  getFormsOfOwnerships() {
    return axios.get(`${ apiPaths.BOOKKEEPING }/forms_of_ownership`);
  },
  getFuelTypes() {
    return axios.get(`${ apiPaths.BOOKKEEPING }/fuel-types`);
  },
};
